import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DNASampleService } from '../../services/dna-sample.service';
import { IDNASample } from "../../interfaces/dna-sample";
import { Location } from '@angular/common';
import { ConfigurationService } from '../../services/configuration.service';
import { IBranding } from '../../interfaces/branding';
import { ErrorService } from '../../services/error.service';
import { UserService } from '../../services/user.service';
import { IUser } from '../../interfaces/user';
import { Permission } from '../../interfaces/permission.enum';
import { IExternalLinks } from '../../interfaces/external-links';

@Component({
    selector: 'app-sample-detail',
    templateUrl: './sample-detail.component.html',
    styles: [],
    standalone: false
})
export class SampleDetailComponent implements OnInit {
  public sample: IDNASample;
  public errorMessage: string;
  public branding: IBranding;
  public externalLinks: IExternalLinks;
  public showSampleCorrection: boolean = false;
  public tempSampleId: string;

  @ViewChild("arresteeWarning") arresteeWarning: TemplateRef<any> = {} as TemplateRef<any>;

  constructor(private readonly titleService: Title,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly modalService: NgbModal,
    private readonly dnaSampleService: DNASampleService,
    private readonly location: Location,
    private readonly configService: ConfigurationService,
    private readonly errorService: ErrorService) { }

  ngOnInit(): void {
    this.titleService.setTitle("DNA Sample Details");

    let currentUser: IUser = this.userService.getCurrentUser();
    this.showSampleCorrection = currentUser.permissions.includes(Permission.CreateSampleCorrection);

    this.tempSampleId = this.route.snapshot.paramMap.get("id");
    this.dnaSampleService.getDNASample(this.tempSampleId)
      .subscribe(data => {
        this.sample = data;
        if (this.sample.showArresteeWarning) {
          this.showArresteeWarning();
        }
      }, error => {
        this.errorMessage = this.errorService.getErrorMessage(error);
      });

    this.configService.getBranding()
      .subscribe(
        data => this.branding = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
    );

    this.configService.getExternalLinks()
      .subscribe(
        data => this.externalLinks = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }

  private showArresteeWarning() {
    this.modalService.open(this.arresteeWarning, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }

  public goBack(e: MouseEvent): void {
    e.preventDefault();
    this.location.back();
  }

  public print(e: MouseEvent): void {
    e.preventDefault();
    window.print();
  }

  public onSampleCorrectionClick(sampleId: number): void {
    this.dnaSampleService.getDNASampleTempId(sampleId)
      .subscribe(
        data => {
          this.router.navigate(["sample", data.tempSampleId, "correction"]);
        },
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }
}
